import { Box } from '@mui/material';
import { AUTH_LOGO_SRC } from './authLegalUrls';

type Props = {
  height?: number;
};

/** Official VisiMe wordmark from `/public/marketing-assets/VisiMe_Logo_RGB-1.png`. */
export default function VisiMeAuthLogo({ height = 36 }: Props) {
  return (
    <Box
      component="img"
      src={AUTH_LOGO_SRC}
      alt="VisiMe"
      sx={{
        height,
        width: 'auto',
        maxWidth: 'min(200px, 70vw)',
        objectFit: 'contain',
        display: 'block',
      }}
    />
  );
}
